import { useEffect } from 'react';

import Head from 'next/head';
import Script from 'next/script';
import { Container } from 'reactstrap';

import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap } from '../../language.config';
import { calendlyLinks } from '../../links.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';

import '../../styles/bookacall.scss';

const BookACall = () => {
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';

  useEffect(() => {
    window.Calendly?.initInlineWidget({
      url: calendlyLinks[country],
      parentElement: document.getElementById('calendlyParent'),
      prefill: {},
      utm: {}
    });
  }, []);

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
        <link rel="stylesheet" href="/vendor/bootstrap/css/bootstrap.min.css" async={true} />
        <Script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" />
      </Head>
      {/* Google Tag Manager (noscript) */}
      {process.env.NEXT_PUBLIC_GTM_ID && (
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_ID}`}
          height="0"
          width="0"
          title="gtag"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      )}
      <section className="bookacall-wrapper">
        <div className="section-head">
          <img src="/img/logo.svg" alt="logo" />
        </div>
        <div className="main-content-wrapper">
          <Container>
            <div className="calendly-inline-widget" id="calendlyParent" data-auto-load="false" />
          </Container>
        </div>

      </section>
    </>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.BOOKACALL;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default BookACall;
